module.exports = __webpack_public_path__ + "img/table.5488c098.png";